import * as CR from '../services/aiOutreachAgents';
import { helpers } from '../utils';

export const ACTION_AI_OUTREACH_AGENTS_LOADLIST = 'aiOutreachAgents/loadList';
export const ACTION_AI_OUTREACH_AGENTS_LOAD_ITEM = 'aiOutreachAgents/loadItem';
export const ACTION_AI_OUTREACH_AGENTS_CREATE = 'aiOutreachAgents/create';
export const ACTION_AI_OUTREACH_AGENTS_UPDATE = 'aiOutreachAgents/update';
export const ACTION_AI_OUTREACH_AGENTS_REMOVE = 'aiOutreachAgents/remove';

export default {
  namespace: 'aiOutreachAgents',
  state: {
    agentsFullList: {},
  },

  reducers: {
    updateStore(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },

  effects: {
    * loadList({ payload }, { call, put }) {
      try {
        const response = yield call(CR.aiOutreachAgentsListRequest, payload);

        yield put({
          type: 'updateStore',
          payload: {
            agentsFullList: {
              [payload.projectId]: response.data,
            },
          },
        });

        return response;
      } catch (e) {
        helpers.processException(e);
      }
    },

    * loadItem({ payload }, { call }) {
      try {
        return yield call(CR.aiOutreachAgentsItemRequest, payload);
      } catch (e) {
        helpers.processException(e);
      }
    },

    * create({ payload }, { call }) {
      try {
        const { data, projectId } = payload;
        return yield call(
          CR.aiOutreachAgentsCreateRequest,
          {
            projectId,
          },
          data,
        );
      } catch (e) {
        helpers.processException(e);
      }
    },

    * update(
      {
        payload: { id, data, projectId },
      },
      { call },
    ) {
      try {
        return yield call(CR.aiOutreachAgentsUpdateRequest, { projectId, id }, { ...data });
      } catch (e) {
        helpers.processException(e);
      }
    },

    * remove(
      {
        payload: { id },
      },
      { call, select },
    ) {
      try {
        const { currentProjectId } = yield select(store => store.app);

        return yield call(CR.aiOutreachAgentsRemoveRequest, {
          projectId: currentProjectId,
          id,
        });
      } catch (e) {
        helpers.processException(e);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/aiOutreachAgents.js